import { InjectionToken } from "@angular/core";

export const APP_RESIZABLE_PARENT = new InjectionToken<IAppResizable>('APP_RESIZABLE_PARENT');

export interface IAppResizable {
  beginResize(): void;
  resize(dx: number, dy: number): void;
  endResize(): void;
};
